import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps, ConfigsProvider } from "react-builder";
import { useFitness } from "../../providers/Fitness";
import { useEffect, useState } from "react";
import { VideoCategory } from "../../providers/Videos";

@AttributeGroup({ title: 'FitnessVideoByCatgoryProvider', blockName: 'FitnessVideoByCategoryProvider', module: 'fitness', icon: 'query' })
export class FitnessVideoByCatgoryProviderAttributes extends Attribute {

    @AttributeProperty({ type: 'String' })
    category: string = 'yoga';
}

const FitnessVideoByCatgoryProviderTheme = styled.div((props: { attributes: FitnessVideoByCatgoryProviderAttributes }) => `

    ${props.attributes.toCSS()}

`);

export function FitnessVideoByCatgoryProvider(props: ComponentProps<FitnessVideoByCatgoryProviderAttributes>) {

    const [videoCategories, setVideoCategories] = useState<VideoCategory[]>();

    const fitness = useFitness();

    useEffect(() => {

        if (props.attributes.category && fitness.loadVideos)
            fitness?.loadVideos(props.attributes.category).then((s) => {
                console.log(fitness.videosBySubCategory);

                // setVideoCategories(fitness.videosBySubCategory)
            })
    }, [fitness.loadVideos])
    useEffect(() => {

        setVideoCategories(fitness.videosBySubCategory)
    }, [fitness.videosBySubCategory])
    return (
        <ConfigsProvider configJson={{ categories: videoCategories ?? [], videos: fitness?.videos }} >
            <>
                {props.children}
            </>
        </ConfigsProvider>
    )
}


FitnessVideoByCatgoryProvider.prototype.Props = FitnessVideoByCatgoryProviderAttributes;


export default FitnessVideoByCatgoryProvider;